<script>
import LayoutHeader from "@/layout/LayoutHeader.vue";
import LayoutFooter from "@/layout/LayoutFooter.vue";

export default {
  name: 'GlobalLayout',
  components: {LayoutFooter, Header: LayoutHeader},
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>

<template>
<div class="global-layout">
  <div class="layout-header">
    <Header></Header>
  </div>
  <div class="layout-content">
    <slot></slot>
    <div class="layout-footer">
      <LayoutFooter></LayoutFooter>
    </div>
  </div>
</div>
</template>

<style scoped lang="less">
.global-layout{
  min-width: 1440px;
  width: 100%;
  height: 100%;
  .layout-header{
    width: 100%;
    height: 80px;
    background: #000;
  }
  .layout-content{
    width: 100%;
    height: calc(100% - 80px);
  }
  .layout-footer{
    width: 100%;
    background-image: url("../../public/images/footer_bg.png");
    background-size: 1920px 419px;
    background-position: bottom -40px center;
    background-repeat: no-repeat;
  }
}
</style>
